import { render, staticRenderFns } from "./AssignEditorForm.vue?vue&type=template&id=20250b84"
import script from "./AssignEditorForm.vue?vue&type=script&lang=ts"
export * from "./AssignEditorForm.vue?vue&type=script&lang=ts"
import style0 from "./AssignEditorForm.vue?vue&type=style&index=0&id=20250b84&prod&lang=scss&module=true"
import style1 from "./AssignEditorForm.vue?vue&type=style&index=1&id=20250b84&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports